module.exports = __webpack_public_path__ + "img/au.b35a142d.svg";